import React, { createContext, useContext, useState } from 'react';
import { useRouteFiltering } from '../useRouteFiltering';

import type {
    GoogleMapsApi,
    GoogleMapsInstance
} from '~/api/types/GoogleMapTypes';
import type {
    PlanMapPropsContextValue,
    PlanMapPropsContextProviderProps
} from './types';

export const PlanMapPropsContext = createContext<PlanMapPropsContextValue>({
    planStops: [],
    routesLevelData: [],
    visibleOnMapRouteData: [],
    mapInstance: null,
    setMapInstance: () => {},
    mapsAPI: null,
    setMapsAPI: () => {}
});

export const usePlanMapPropsContext = () => useContext(PlanMapPropsContext);

export const PlanMapPropsContextProvider = ({
    children,
    planStops = [],
    routesLevelData = []
}: PlanMapPropsContextProviderProps) => {
    const [mapInstance, setMapInstance] = useState<GoogleMapsInstance | null>(
        null
    );
    const [mapsAPI, setMapsAPI] = useState<GoogleMapsApi | null>(null);

    const { visibleOnMapRouteData } = useRouteFiltering({
        routesLevelData
    });

    return (
        <PlanMapPropsContext.Provider
            value={{
                planStops,
                routesLevelData,
                visibleOnMapRouteData,
                mapInstance,
                setMapInstance,
                mapsAPI,
                setMapsAPI
            }}
        >
            {children}
        </PlanMapPropsContext.Provider>
    );
};
